import { observable } from "mobx";

export type InitialProps = {
  inputName: string;
  value?: string;
  dateFormat?: string;
  timeFormat?: string;
};

let store: Store | undefined;

export function getStore() {
  if (!store) {
    throw new Error("Store not initialized");
  }
  return store;
}

export function createStore(props: InitialProps) {
  store = new Store(props);
}

class Store {
  readonly inputName: string;
  readonly dateFormat?: string;
  readonly timeFormat?: string;
  @observable accessor value = "";

  constructor(props: InitialProps) {
    this.inputName = props.inputName;
    this.value = props.value ?? "";
    this.dateFormat = props.dateFormat;
    this.timeFormat = props.timeFormat;
  }
}
